namespace Areas.Maintenance.List {
    "use strict";

    var accountsMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["Account", "AccountTeam", "AccountWorkOrder", "FundingSource", "GLFiscalYear"])

    var employeeMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["Employee", "EmployeeAccrualCalc", "EmployeeAccrualRate", "EmployeeAccrualType"])

    var personnelMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["Contact", "ContactDepartmentUnit", "EmployeeAccrualCalc", "Holiday", "TimeEntryTaskCode",
            "RechargeRate"])

    var rechargeMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["RechargeRate", "RechargeRateHistory"])

    var systemMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["AuthorizedUser", "SystemConfigSettings", "SystemUsers"])


    export function accountsMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(accountsMaintenanceTabItems)(params);
    }

    export function employeeMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(employeeMaintenanceTabItems)(params);
    }

    export function personnelMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(personnelMaintenanceTabItems)(params);
    }

    export function rechargeMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(rechargeMaintenanceTabItems)(params);
    }

    export function systemMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(systemMaintenanceTabItems)(params);
    }
}